module.exports = __webpack_public_path__ + "f20eafb047cb6a1174367b42e4692350.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img1.jpeg
// module id = 1327
// module chunks = 0